import {memo, useEffect, useState} from 'react';

const UTCText = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    const update = () => {
      setText(
        new Date().toLocaleTimeString('en-GB', {
          timeZone: 'UTC',
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      );
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ml-[18px] flex items-center">
      <div className="h-[30px] w-px bg-border" />
      <span className="ml-[18px] text-sm text-spanish-gray-1">
        UTC: {text}
      </span>
    </div>
  );
};

export default memo(UTCText);
